export default __webpack_public_path__ + "static/media/calendar.7cf41a2e.svg";